export default "__VITE_ASSET__DaBZ9Dmg__"